<h2 mat-dialog-title class="timeline-item-dialog-title">
    {{'moods_not_saved_modal_title' | translate}}  
</h2>

<mat-dialog-content class="dialog-content-pad-15">   
    <p>{{'moods_not_saved_modal_content' | translate}}</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button"
            class="btn btn-default"
            (click)="onClose()">{{'moods_not_saved_modal_cancel_comment_button' | translate}}</button>
    <button type="button"
            class="btn btn-primary"
            data-cy="user-activity-modal-submit"
            (click)="saveComment()">{{'moods_not_saved_modal_post_button' | translate }} <i class="far fa-check"></i></button>
</mat-dialog-actions>